module.exports = __webpack_public_path__ + "static/media/winning_1.a4511cbd.mp3";